import { VuexModule, RegisterOptions } from "vuex-class-modules";
import { Api } from "../../../../common/src/api/Api";
import { UserFavoriteConferenceListStore } from "./UserFavoriteConferenceListStore";
import { UserFavoriteOrganizationListStore } from "./UserFavoriteOrganizationListStore";
import { UserActivityLogsListStore } from "./UserActivityLogsListStore";
import { injectable } from "inversify";
import { OrganizationFilterStore } from "../organization/OrganizationFilterStore";
import { AnalyticFilter } from "@gsx/common";

@injectable()
export class UserEditFavoriteStore extends VuexModule {
    constructor(
        private readonly api: Api,
        private readonly userFavoriteConferenceListStore: UserFavoriteConferenceListStore,
        private readonly userFavoriteOrganizationListStore: UserFavoriteOrganizationListStore,
        private readonly userActivityLogsListStore: UserActivityLogsListStore,
        private readonly organizationFilterStore: OrganizationFilterStore,
        options: RegisterOptions,
    ) {
        super(options);
    }

    public async addConference(conferenceId: string): Promise<void> {
        await this.api.launchpad.userFavorites.conference.create(conferenceId);
        await this.userFavoriteConferenceListStore.reload();
        await this.userActivityLogsListStore.reload();
    }

    public async removeConference(conferenceId: string): Promise<void> {
        await this.api.launchpad.userFavorites.conference.delete(conferenceId);
        await this.userFavoriteConferenceListStore.reload();
        await this.userActivityLogsListStore.reload();
    }

    public async addOrganization(organizationId: string): Promise<void> {
        await this.api.launchpad.userFavorites.organization.create(organizationId);
        await this.userFavoriteOrganizationListStore.reload();
        await this.userActivityLogsListStore.reload();
    }

    public async removeOrganization(organizationId: string): Promise<void> {
        await this.api.launchpad.userFavorites.organization.delete(organizationId);
        await this.userFavoriteOrganizationListStore.reload();
        await this.userActivityLogsListStore.reload();
    }

    public async addAnalytic(analyticId: string): Promise<void> {
        const filters: AnalyticFilter = {
            logicalOperator: this.organizationFilterStore.logicalOperator,
            services: [...this.organizationFilterStore.serviceTags],
            products: [...this.organizationFilterStore.productTags],
            applicationTags: [...this.organizationFilterStore.applicationTags],
            operatingRegimeTags: [...this.organizationFilterStore.operatingRegimeTags],
            countries: [...this.organizationFilterStore.countries],
        };

        await this.api.launchpad.userFavorites.analytics.create(analyticId, filters);
        await this.userActivityLogsListStore.reload();
    }

    public async removeAnalytic(analyticId: string): Promise<void> {
        await this.api.launchpad.userFavorites.analytics.delete(analyticId);
        await this.userActivityLogsListStore.reload();
    }
}
